export default __webpack_public_path__ + "static/media/correct12.ea44d5ef.mp3";